module.exports = __webpack_public_path__ + "img/Terranova_Img1.png.8d220ea4.png";